/* eslint-disable @typescript-eslint/no-explicit-any */
type TrackingEvent = 'visit page' | 'click button' | 'request api'

export interface TrackingInterface {
  user_id?: string
  event: TrackingEvent
  location?: any
  date?: string
  [key: string]: any
}

class Tracking {
  private static tracking: Tracking
  public static getInstance(): Tracking {
    if (!Tracking.tracking) {
      Tracking.tracking = new Tracking()
    }
    return Tracking.tracking
  }

  // constructor() {}

  public trackingApi(url: string, payload: TrackingInterface) {
    window.bizlink
      .tracking(url, {
        ...payload
      })
      .then((result: any) => {
        console.log('tracking complete', result)
      })
      .catch((err: any) => {
        console.error('tracking fail', err)
      })
  }
}

export default Tracking
